import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import * as types from "@/store/constants/types";
import textContent from "@/components/textContent/textContent.vue";
import { getLang } from '@/api/utils/apiHelper';
import { sendMapEvent } from "@/utils/analytics";

var SlecteFate =
/*#__PURE__*/
function (_Vue) {
  _inherits(SlecteFate, _Vue);

  function SlecteFate() {
    _classCallCheck(this, SlecteFate);

    return _possibleConstructorReturn(this, _getPrototypeOf(SlecteFate).apply(this, arguments));
  }

  _createClass(SlecteFate, [{
    key: "tryNow",
    value: function tryNow() {
      sendMapEvent("uia_card_click", {
        key: "horoscope"
      });
      this.routerPush({
        name: "chooseZodiac",
        params: {
          routerTransition: "forward"
        }
      });
    }
  }, {
    key: "tryText",
    get: function get() {
      return this.$t("home_page.slecte_fate.try_text");
    }
  }, {
    key: "isGerman",
    get: function get() {
      return getLang() === "de";
    }
  }, {
    key: "isFrench",
    get: function get() {
      return getLang() === "fr";
    }
  }, {
    key: "isSpanish",
    get: function get() {
      return getLang() === "es";
    }
  }, {
    key: "tryNowText",
    get: function get() {
      return this.isGerman || this.isFrench || this.isSpanish ? this.$t("home_page.slecte_fate.try") : this.$t("home_page.slecte_fate.try_now");
    }
  }]);

  return SlecteFate;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], SlecteFate.prototype, "routerPush", void 0);

SlecteFate = tslib_1.__decorate([Component({
  components: {
    textContent: textContent
  }
})], SlecteFate);
export default SlecteFate;